import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { settings } from '../../lib/settings';

class Collapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: settings.get(`preferences.${props.id}`, true),
    };
  }

  toggleCollapse() {
    const newState = !this.state.open;
    settings.set(`preferences.${this.props.id}`, newState, true);
    this.setState({ open: !this.state.open });
  }

  render() {
    const { title = '', children = [], height = '150px' } = this.props;
    const { open } = this.state;
    const extras = {};
    if (!open) {
      extras.padding = '0px';
    }

    return (
      <div className='collapseable' {..._.omit(this.props, ['children'])}>
        <div
          className='collapse-title'
          onClick={this.toggleCollapse.bind(this)}
          tabIndex={-1}
          role='button'
        >
          {title}
          <i
            className={open ? 'fas fa-angle-down' : 'fas fa-angle-right'}
          />
        </div>
        {children && !_.isEmpty(children) ?
          <div
            className='collapse-content'
            data-open={open}
            style={{
              height: height || '300px',
              ...extras,
            }}
          >
            {children}
          </div> : null }
      </div>
    );
  }
}

Collapse.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.shape({}), PropTypes.string]),
  title: PropTypes.string,
  open: PropTypes.bool,
  height: PropTypes.string,
};

Collapse.defaultProps = {
  children: [],
  title: '',
  open: true,
  height: '150px',
};

export default Collapse;



// WEBPACK FOOTER //
// ./src/views/Components/Collapse.js